// Configurator Support
export const MAX_ATTACHMENTS = Number.POSITIVE_INFINITY;
export const MAX_SUPPORT_TEXT_AREA_LENGTH = 30000;
export const MAX_SUPPORT_INPUT_LENGTH = 255;
export const MAX_SUPPORT_SUBJECT_LENGTH = 50;
export const MAX_ATTACHMENT_SIZE_MB = 14;

export const ALLOWED_EXTENSIONS = new Set([
  ".pdf",
  ".png",
  ".jpg",
  ".jpeg",
  ".txt",
  ".doc",
  ".docx",
  ".xls",
  ".xlsx",
]);

export const ALLOWED_MIME_TYPES = new Set([
  "image/png",
  "image/jpeg",
  "application/pdf",
  "application/vnd.ms-excel",
  "application/vnd.ms-powerpoint",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "text/plain",
]);
